<script>
import { formatDate } from "../../helpers/functions_helpers.js";
import { EventBus } from "../../hermeneus.eventbus/eventbus.js";
import { sharesRessourcesMixin } from "../../mixins/sharesRessources.mixin.js";
import { haxiosAPIClient } from "@/haxios/haxios.js";
import { wait } from "@/helpers/functions_helpers.js";
import UebungenLibraryAbsolvedStatsDashboard from "./AbsolvedStatsComponents/UebungenLibraryAbsolvedStatsDashboard.vue";
export default {
  name: "uebungen-library-index-uebung",
  mixins: [sharesRessourcesMixin],
  components: {
    'uebungen-library-absolved-stats-dashboard': UebungenLibraryAbsolvedStatsDashboard
  },
  props: {
    uebung: Object,
    displayFilter: {
      type: String,
      default: "all",
    },
    uebung_key: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      isAnimating: false,
      isActiveAbsolvedDashboard: false,
      isHovering: false
    };
  },
  methods: {
    shareUebung() {
      this.openShareModalForUebung(this.uebung);
    },
    openEditUebungModal() {
      EventBus.$emit('uebungen-library__open-edit-modal', {
        uebung: this.uebung,
      });
    },
    async showEditConfirmMessage() {
      const response = await haxiosAPIClient.get(`/uebungen/absolved-records/check/${this.uebung.id}`);
      if (response.data.data.uebung.length > 0) {
        this.$IrisMessenger.confirm({
          type: 'info',
          title: 'Übungsergebnisse löschen?',
          message: `Die Übung wurde bereits von Benutzern absolviert und es wurden Ergebnisstatistiken gespeichert. Wenn Sie die Übung bearbeiten wollen, dann 
          müssen diese Statistiken gelöscht werden, damit es nicht zu Verzerrungen kommt. Wollen Sie die Ergebnisse löschen, um die Übung zu bearbeiten?`,
          callback: this.deleteAbsolvedRecordsAndOpenEditModal
        });
        return;
      }

      this.openEditUebungModal();
    },
    async deleteAbsolvedRecordsAndOpenEditModal() {
      const response = await haxiosAPIClient.post(`/uebungen/absolved-records/delete/${this.uebung.id}`);
      this.openEditUebungModal();
    },
    toggleAbsolvedDashboard() {
      this.isActiveAbsolvedDashboard = !this.isActiveAbsolvedDashboard;
    },
    deleteUebung() {

      let DeleteFunction = async () => {
        haxiosAPIClient.post('/uebungen/delete/' + this.uebung.id).then(async (response) => {
          this.$IrisMessenger.dialog({ type: 'success', title: 'Übung gelöscht', message: `Die Übung wurde gelöscht.`, selfDestructTimer: 2000 });
          await wait(500);
          EventBus.$emit('requested-uebungen-fetch');
        }).catch(error => {
          console.error(error);
          this.$IrisMessenger.dialog({ type: 'danger', title: 'Fehler', message: `Die Übung konnte nicht gelöscht werden.`, selfDestructTimer: 2000 });
        });

      };
      this.$IrisMessenger.confirm({
        type: 'danger',
        title: 'Übung löschen?',
        message: `Soll die Übung gelöscht werden?`,
        callback: DeleteFunction
      });
    },

    formatDate: formatDate,
    addAnimationTrigger() {
      this.$refs[`uebung-${this.uebung_key}`].classList.add('hover-trigger');
      this.isHovering = true;
    },
    removeAnimationTrigger() {
      this.$refs[`uebung-${this.uebung_key}`].classList.remove('hover-trigger');
      this.isHovering = false;
    },
    openAbsolveModal(event) {
      // Hole die Position des Buttons
      const button = event.currentTarget;
      const rect = button.getBoundingClientRect();

      const position = {
        x: rect.left + (rect.width / 2),
        y: rect.top + (rect.height / 2)
      };

      this.isAnimating = true;
      setTimeout(() => {
        this.isAnimating = false;
      }, 300);

      EventBus.$emit('uebungen-library__open-absolve-modal', {
        uebung: this.uebung,
        position: position
      });
    },
    openPrintModal(event) {
      event.preventDefault();
      event.stopPropagation();

      const button = event.currentTarget;
      const rect = button.getBoundingClientRect();

      const position = {
        x: rect.left + (rect.width / 2),
        y: rect.top + (rect.height / 2)
      };

      this.isAnimating = true;

      setTimeout(() => {
        EventBus.$emit('uebungen-library__open-print-uebung-modal', {
          uebung: this.uebung,
          uebung_key: this.uebung_key,
          position: position
        });

        setTimeout(() => {
          this.isAnimating = false;
        }, 300);
      }, 200);
    }
  },
  computed: {
    resolvedUebung() {
      return this.$resolveUebungFromRegistry(this.uebung.uebung_type);
    },
    categoryColor() {
      try {
        return this.$UebungenRegistry.registered_categories[this.resolvedUebung.category].color;
      } catch (e) {
        console.info(this.uebung);
        return '#000000';
      }
    }
  },
  mounted: function () {
  }
}
</script>

<template>
  <div :ref="`uebung-${uebung_key}`" @mouseover="addAnimationTrigger()" @mouseout="removeAnimationTrigger()"
    class="uebungen-library__uebung rounded-lg overflow-hidden shadow-md hover:shadow-xl mb-4 transition-all duration-300 transform hover:-translate-y-1">

    <div class="flex flex-row">
      <!-- CATEGORY-THUMB -->
      <div class="uebungen-library__uebung__category-thumb flex-shrink-0">
        <div class="h-full xl-plus:w-24 p-4 flex flex-col justify-start items-center transition-all duration-300"
          :style="`background-color: ${this.categoryColor}`">
          <div class="flex justify-center items-center flex-col opacity-75 lg-minus:hidden">
            <hermeneus-icon height="45" width="45" :name="`hi-uebung-category-${resolvedUebung.category}`"
              color="text-white" class="mb-2 lg-minus:hidden"></hermeneus-icon>
            <div class="text-sm font-medium text-center xl-minus:hidden text-white" :class="{ 'opacity-0': !isHovering }">
              {{ this.$UebungenRegistry.registered_categories[resolvedUebung.category].title }}
            </div>
          </div>
        </div>
      </div>

      <!-- CONTENT SECTION -->
      <div class="flex-grow flex flex-col">
        <div class="flex-grow bg-white flex flex-row">
        <!-- ICON AND TITLE -->
        <div class="uebungen-library__uebung__icon-title flex flex-row w-2/3 border-r border-grey-200">
          <!-- THUMBNAIL -->
          <div class="uebungen-library__thumbnail p-4 flex items-center justify-center">
            <div class="bg-grey-50 rounded-full p-3 transition-all duration-300 hover:bg-grey-100 xl-minus:hidden">
              <hermeneus-icon height="48" width="48" :name="resolvedUebung.appearance.icon"
                class="text-grey-700"></hermeneus-icon>
            </div>
          </div>

          <!-- TITLE AND DATE -->
          <div class="p-4 text-left flex-grow flex flex-col justify-center">
            <div class="mb-2">
              <div v-if="uebung.specific_uebung" class="flex flex-col w-full">
                <h3 class="lg-minus:text-lg  xl-plus:text-xl font-bold text-grey-800 line-clamp-2 leading-tight">
                  {{ uebung.specific_uebung.title }}
                </h3>
              </div>
              <div v-else class="text-red-500 font-medium">
                Keine spezifische Übung gefunden! <br>
                <span class="text-xs bg-white font-mono">({{ uebung.uebung_type }})</span>
              </div>
            </div>
            <div class="h-5 p-2"></div>

            <div class="flex flex-row items-center text-sm text-grey-500">
              <span class="flex items-center">
                <i class="far fa-calendar-alt mr-2"></i>
                <span class="font-medium">{{ formatDate(uebung.created_at) }}</span>
              </span>
            </div>
          </div>

          <!-- ACTION BUTTONS -->
          <div class="flex flex-row items-center p-4 space-x-1">
            <button
              class="text-grey-500 hover:text-grey-700 p-2 rounded-full hover:bg-grey-100 transition-all duration-200 tooltip"
              data-tooltip="Teilen" @click="shareUebung">
              <i class="bx bx-share-alt text-xl"></i>
            </button>
            <button
              class="text-grey-500 hover:text-grey-700 p-2 rounded-full hover:bg-grey-100 transition-all duration-200 tooltip"
              data-tooltip="Ergebnis-Dashboard" @click="toggleAbsolvedDashboard">
              <i class="bx bx-bar-chart-alt-2 text-xl"></i>
            </button>
            <button
              class="text-grey-500 hover:text-grey-700 p-2 rounded-full hover:bg-grey-100 transition-all duration-200 tooltip"
              @click="showEditConfirmMessage"
              :disabled="!resolvedUebung.options.is_editable"
              :class="{ 'opacity-50 cursor-not-allowed': !resolvedUebung.options.is_editable }"
              data-tooltip="Bearbeiten">
              <i class="fa-regular fa-pen-to-square text-xl"></i>
            </button>
            <button
              class="text-grey-500 hover:text-red-500 p-2 rounded-full hover:bg-grey-100 transition-all duration-200 tooltip"
              data-tooltip="Löschen" @click="deleteUebung(uebung)">
              <i class="fa-regular fa-trash-can text-xl"></i>
            </button>
          </div>
        </div>

        <!-- MAIN BUTTONS -->
        <div class="uebungen-library__uebung__body w-1/3 flex items-center justify-center p-4 bg-white">
          <div class="flex flex-row space-x-4 w-full">
            <!-- START BUTTON -->
            <button @click="openAbsolveModal" :class="{ 'button-clicked': isAnimating }"
              :disabled="!resolvedUebung.options.is_absolvable"
              class="button-play flex-1 flex flex-row justify-center items-center py-2 px-4 rounded-lg bg-primary-600 text-white hover:bg-primary-700 transition-all duration-300 transform disabled:opacity-50 disabled:hover:bg-primary-600 disabled:hover:text-white disabled:hover:shadow-md hover:scale-105 shadow-md">
              <hermeneus-icon height="28" width="28" name="hi-uebung-play" color="text-white"></hermeneus-icon>
              <span class="font-bold lg-minus:hidden ml-4 mt-1 z-[1000]">Starten</span>
            </button>

            <!-- PRINT BUTTON -->
            <button @click="openPrintModal"
              :disabled="!resolvedUebung.options.is_printable"
              :class="{ 'opacity-50 cursor-not-allowed': !resolvedUebung.options.is_printable }"
              class="button-print flex-1 flex flex-row justify-center items-center py-3 px-4 rounded-lg border-2 border-grey-300 text-grey-700 hover:border-primary-600 hover:text-primary-700 transition-all duration-300 transform hover:scale-105">
              <hermeneus-icon height="28" width="28" name="hi-uebung-print" color="current"></hermeneus-icon>
              <span class="font-medium lg-minus:hidden ml-3 mt-1">Drucken</span>
            </button>
          </div>
        </div>
        </div>

        <!-- EXPANDABLE RESULT-DASHBOARD -->
        <transition name="slide-down">
            <uebungen-library-absolved-stats-dashboard v-if="isActiveAbsolvedDashboard" :uebung="uebung"></uebungen-library-absolved-stats-dashboard>
        </transition>
      </div>

    </div>
  </div>
</template>

<style scoped>
.uebungen-library__uebung {
  transition: all 0.3s ease;
  background-color: #ffffff;
  position: relative;
  /* Für die absolute Positionierung des Overlays */
}

@keyframes gradientAnimation {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.hover-trigger {
  box-shadow: 0 10px 15px -3px theme('colors.grey.300'), 0 4px 6px -2px theme('colors.grey.300');
}

.tooltip {
  position: relative;
}

.tooltip::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: -22px;
  left: 50%;
  transform: translateX(-50%);
  padding: 2px 6px;
  background-color: theme('colors.grey.100');
  color: theme('colors.grey.700');
  border-radius: 4px;
  font-size: 11px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  z-index: 1000;
}

.tooltip:hover::after {
  opacity: 1;
  visibility: visible;
}

.button-clicked {
  transform: scale(0.95);
  transition: all 0.25s ease;
}
</style>